module.exports = __webpack_public_path__ + "img/1f911.10d4577.svg";